import { useState } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { Link } from 'react-router-dom';
import './burgirMenuStyle.css';
import { useSelector } from 'react-redux';

const BurgirMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useSelector((state) => state.auth);

  if (!user?._id) {
    return null;
  }
  return (
    <Menu isOpen={isOpen} onOpen={() => setIsOpen((isOpen) => !isOpen)}>
      <Link onClick={() => setIsOpen(() => false)} to='/conditions'>
        <b>Conditions</b>
      </Link>
      <Link onClick={() => setIsOpen(() => false)} to='/Actions'>
        <b>Actions</b>
      </Link>
      <Link onClick={() => setIsOpen(() => false)} to='/Rules'>
        <b>Rules</b>
      </Link>
      <h4>------------</h4>
      <Link onClick={() => setIsOpen(() => false)} to='/ruleGroups'>
        <b>Rule Groups</b>
      </Link>
      <Link onClick={() => setIsOpen(() => false)} to='/RunRules'>
        <b>Run Rules</b>
      </Link>
      <Link onClick={() => setIsOpen(() => false)} to='/RetryRules'>
        <b>Retry Rules</b>
      </Link>
      <h4>------------</h4>
      <Link onClick={() => setIsOpen(() => false)} to='/chooseAdAccount'>
        <b>Ad Account Dashboard</b>
      </Link>

      <Link onClick={() => setIsOpen(() => false)} to='/CreateGeneralSettings'>
        <b>Create Settings</b>
      </Link>
      <h4>------------</h4>
      {/* <Link onClick={() => setIsOpen(() => false)} to='/pendingduplications'>
        <b>Pending Duplications</b>
      </Link> */}
      <Link onClick={() => setIsOpen(() => false)} to='/pendingAds'>
        <b>Pending Ads</b>
      </Link>
      <h4>------------</h4>
      <Link onClick={() => setIsOpen(() => false)} to='/incomingwebhooks'>
        <b>Webhooks</b>
      </Link>
      <Link onClick={() => setIsOpen(() => false)} to='/timeTemplates'>
        <b>Time Templates</b>
      </Link>
      <Link onClick={() => setIsOpen(() => false)} to='/GeneralSettings'>
        <b>General Settings</b>
      </Link>
      <Link onClick={() => setIsOpen(() => false)} to='/AlternativePagesCron'>
        <b>Alternative Pages</b>
      </Link>
      <Link onClick={() => setIsOpen(() => false)} to='/sqlValues'>
        <b>SQL Values</b>
      </Link>
      <Link onClick={() => setIsOpen(() => false)} to='/logs'>
        <b>Logs</b>
      </Link>
    </Menu>
  );
};

export default BurgirMenu;
